import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import telegramQr from "../../assets/img/mangerQR.png";

// Экран «Место под рекламу» — карточка со ссылкой из RouteList. Реальной
// рекламной кампании ещё нет, поэтому вместо неё — приглашение связаться
// с менеджером через Telegram, чтобы разместить рекламу на этом терминале.
const blockVariants = {
    hidden: { opacity: 0, y: 24 },
    visible: (i) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.45, delay: i * 0.1 },
    }),
};

function AdvertisementPage() {
    const { t } = useTranslation();

    return (
        <div className="h-[88vh] px-[2.4vw] py-[2vh] flex flex-col gap-[1.6vh] bg-[#EDEFF4]">
            <motion.div
                variants={blockVariants}
                initial="hidden"
                animate="visible"
                custom={0}
                className="flex-none bg-white rounded-[3vh] shadow-[0_0.5vh_2vh_rgba(18,22,31,0.08)] px-[2.4vw] py-[2.6vh] flex items-center gap-[1.6vw]"
            >
                <div className="w-[6vh] h-[6vh] rounded-[1.6vh] bg-[#E3ECFB] flex items-center justify-center flex-none">
                    <svg
                        className="w-[3vh] h-[3vh]"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#246CE2"
                        strokeWidth="1.9"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M3 11v2a1 1 0 0 0 1 1h3l4 4V6l-4 4H4a1 1 0 0 0-1 1Z" />
                        <path d="M16 8a4 4 0 0 1 0 8M19.5 5.5a8 8 0 0 1 0 13" />
                    </svg>
                </div>
                <div className="min-w-0">
                    <h1 className="text-[2.6vh] font-extrabold tracking-tight">
                        {t("advertisement.title")}
                    </h1>
                    <p className="text-[1.5vh] font-semibold text-[#7B8290] mt-[0.4vh]">
                        {t("advertisement.subtitle")}
                    </p>
                </div>
            </motion.div>

            <motion.div
                variants={blockVariants}
                initial="hidden"
                animate="visible"
                custom={1}
                className="flex-1 min-h-0 bg-white rounded-[3vh] shadow-[0_0.5vh_2vh_rgba(18,22,31,0.08)] px-[2.4vw] py-[2.6vh] flex items-center justify-center gap-[3vw]"
            >
                <img
                    src={telegramQr}
                    alt={t("advertisement.qr_alt")}
                    className="w-[30vh] h-[30vh] rounded-[2.4vh] border-[0.3vh] border-[#E1E4EB] p-[1.2vh] bg-white flex-none object-cover"
                />
                <div className="max-w-[36vw]">
                    <h2 className="text-[2.2vh] font-extrabold tracking-tight leading-tight">
                        {t("advertisement.scan_qr")}
                    </h2>
                    <p className="text-[1.5vh] font-semibold text-[#7B8290] mt-[1.2vh] leading-relaxed">
                        {t("advertisement.manager_info")}
                    </p>
                </div>
            </motion.div>
        </div>
    );
}

export default AdvertisementPage;
